<template>
  <portal to="sidebar-menu">
    <div>
      <slot name="before"></slot>
      <section-separator class="group-separator mt-0 " v-if="$can('admin-orders-view')">
        {{$t('ecommerce.menu.orders')}}
      </section-separator>
      <saved-filters :entity="entities.ORDER"></saved-filters>
      <nav-list class="mt-2" :items="allNavigationItems"></nav-list>
      <slot name="after"></slot>
    </div>
  </portal>
</template>
<script>

  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'
  import SavedFilters from 'src/components/Filters/SavedFilters'

  export default {
    name: 'ecommerce-left-menu',
    components: {
      SavedFilters
    },
    props: {
      navigationItems: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        entities,
        baseNavigationItems: [
          {
            type: 'group',
            name: this.$t('ecommerce.menu.credits'),
            hide: !this.$can('admin-orders-view'),
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CREDIT),
            hide: !this.$can('admin-credits-view'),
            name: this.$t('ecommerce.menu.creditBalance')
          },
          {
            routeName: getRouteName('credit-logs', entities.SETTINGS),
            hide: !this.$can('admin-credits-view'),
            name: this.$t('ecommerce.menu.creditLogs')
          },
          {
            type: 'group',
            name: this.$t('ecommerce.menu.contracts'),
            hide: !this.$can('admin-orders-view'),
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CONTRACT),
            hide: true,
            name: this.$t('ecommerce.menu.contractBalance')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CONTRACT),
            hide: !this.$can('admin-credits-view'),
            name: this.$t('ecommerce.menu.contracts')
          },
          {
            type: 'group',
            name: this.$t('ecommerce.menu.subscriptions'),
            hide: !this.$can('admin-orders-view'),
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.SUBSCRIPTION),
            name: this.$t('ecommerce.menu.subscriptions')
          },
          {
            type: 'group',
            name: this.$t('invoice.menu.invoices'),
            hide: !this.$can('admin-orders-view'),
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.INVOICE),
            name: this.$t('invoice.menu.invoices')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.INVOICE_LINE),
            name: this.$t('invoice.menu.invoiceLines')
          },
          {
            routeName: getRouteName('bulk-invoices', entities.SETTINGS),
            name: this.$t('routes.titles.bulkInvoices')
          },
        ]
      }
    },
    computed: {
      allNavigationItems () {
        return this.baseNavigationItems.concat(this.navigationItems)
      }
    }
  }
</script>
<style>
</style>
